import { c as _c } from "react/compiler-runtime";
import { faBridgeAndStripe, faBridgeHorizontal, faBridgeMark, faBridgeSquare, faBridgeWord } from '@icons/kit/custom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
const LOGO_VARIANTS = {
  'and-stripe': faBridgeAndStripe,
  horizontal: faBridgeHorizontal,
  mark: faBridgeMark,
  square: faBridgeSquare,
  word: faBridgeWord
} as const satisfies Record<string, IconDefinition>;
type LogoVariant = keyof typeof LOGO_VARIANTS;
interface LogoProps {
  className?: string;
  size?: FontAwesomeIconProps['size'];
  variant?: LogoVariant;
}
function Logo(t0) {
  const $ = _c(7);
  const {
    className,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? "2x" : t1;
  const variant = t2 === undefined ? "mark" : t2;
  let t3;
  if ($[0] !== size) {
    t3 = size === "4x" ? {
      width: "70px",
      height: "56px"
    } : undefined;
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const style = t3;
  const t4 = LOGO_VARIANTS[variant];
  let t5;
  if ($[2] !== className || $[3] !== size || $[4] !== style || $[5] !== t4) {
    t5 = <FontAwesomeIcon className={className} aria-label="Bridge" icon={t4} size={size} style={style} />;
    $[2] = className;
    $[3] = size;
    $[4] = style;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
export { Logo, LOGO_VARIANTS };
export type { LogoProps, LogoVariant };